export default __webpack_public_path__ + "static/media/nodejs.3646fb6d.svg";